import { useEffect, useState } from "react";
import api, { fmtDT } from "@/lib/api";
export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-semibold">Audit Logs</h1>
      <div className="bg-white border">
        <table className="w-full text-sm">
          <thead><tr className="bg-slate-50 text-left"><th className="label-tiny p-2">Time</th><th className="label-tiny">User</th><th className="label-tiny">Role</th><th className="label-tiny">Action</th><th className="label-tiny">Ref</th></tr></thead>
          <tbody>{rows.map((r) => <tr key={r.id} className="border-b"><td className="p-2 font-mono text-xs">{fmtDT(r.ts)}</td><td>{r.user_email}</td><td>{r.role}</td><td className="font-mono text-xs">{r.action}</td><td className="font-mono text-xs">{r.ref_id}</td></tr>)}</tbody>
        </table>
      </div>
    </div>
  );
}
